import { useAppSelector } from "integrations/redux/hooks"
import { PropsWithChildren } from "react"
import { selectImagePreviewContext } from "features/map/layers/selectors"

export const ImagePreviewContainer = ({ children }: PropsWithChildren) => {
    const previewModalContext = useAppSelector(selectImagePreviewContext())
    if (!previewModalContext) return null
    return <div className="rounded-md bg-black-800 p-2 w-fit">{children}</div>
}
